import { API } from "aws-amplify";

export default async function getBankLetterDetail(accountNumber) {
  if (accountNumber) {
    return await API.get("bankLetter", `details/${accountNumber}`);
  }
}
